<section class="global-standards-section section-padding vw-100 overflow-hidden" [ngClass]="{'pt-0': isPage}">
  <div class="container container-max">
    <div class="row g-5">
      <div class="col-md-6">
        <span class="section-subtitle-pill bg-success text-white">Global Standards</span>
        <h2 class="section-title mt-2 mb-4">Engineered on the Beneficial Ownership Data Standard (BODS)</h2>
        <div class="fs-15 opacity-80p">
          <p class="pb-3">Nigeria is proudly leading in African govtech by implementing structural transparency schemas mapped directly to Open Ownership frameworks.</p>
          <p class="pb-3">Our platform features continuous integration with global transparency watchdogs and interfaces seamlessly via high-grade Enterprise Service Bus (ESB) gateways for real-time inter-agency intelligence.</p>
        </div>
      </div>
      <div class="col-md-6">
        <div class="json_sample mt-md-5">
          <h4 class="title mb-3">BODS JSON INTEGRITY SCHEMA</h4>
          <pre class="sample">{{ jsonSample }}</pre>
        </div>
      </div>
    </div>
    <div class="border-top border-white border-opacity-10 my-5"></div>
    <div class="d-flex align-items-center flex-wrap gap-3 heading-font">
      <div class="opacity-80p">GLOBAL CO-DEVELOPMENT PARTNERS:</div>
      <ul class="list-unstyled d-flex align-items-center justify-content-evenly gap-3 flex-grow-1 flex-wrap">
        <li class="d-flex align-items-center gap-2">
          <iconify [name]="'icon-park-outline:dot'" [size]="16" class="text-success" />
          World Bank Group
        </li>
        <li class="d-flex align-items-center gap-2">
          <iconify [name]="'icon-park-outline:dot'" [size]="16" class="text-success" />
          Open Ownership
        </li>
        <li class="d-flex align-items-center gap-2">
          <iconify [name]="'icon-park-outline:dot'" [size]="16" class="text-success" />
          FATF Aligned
        </li>
      </ul>
    </div>
  </div>
</section>
